
import { ApiAxios } from '../ApiAxios';
import { Api } from '../Api';
import { AvaliacaoPersistida } from 'model/solicitacao/avaliacao/AvaliacaoPersistida';
import { Avaliacao } from 'model/solicitacao/avaliacao/Avaliacao';
import { AvaliacaoDTO } from 'model/solicitacao/avaliacao/AvaliacaoDTO';


export class ApiAvaliacao {
  static async getAvaliacoesByIdSolicitacao(idSolicitacao: number): Promise<Avaliacao[]> {
    const response = await ApiAxios.instance.get(`/reinos/${Api.REINO_PADRAO}/solicitacoes/${idSolicitacao}/avaliacoes`)

    return response.data;
  }

  static async avaliarSolicitacao(idSolicitacao: number, avaliacao: AvaliacaoDTO): Promise<AvaliacaoPersistida> {
    const response = await ApiAxios.instance.post(`/reinos/${Api.REINO_PADRAO}/solicitacoes/${idSolicitacao}/avaliar`, avaliacao)
    return response.data
  }
}
